<template>
	<div id="ShareProjectBox" :class="[{'hden': !isProjectAssociationVisible}, 'overlay']" :data-accentcolor="accentColor ? accentColor : null">
		<div class="layer" data-size="small">
			<div class="top" :style="[{'background-color': headerColor}]">
				<div @click="closeDialog()" class="close icon fastic-close" :style="[{'color': menuColor}]"></div>
				<div class="title" :style="[{'color': menuColor}]">{{ localizer.get("PrivateArea.Project.ShareTitle") }}</div>
			</div>
			<div class="content">
				<div class="add form">
					<div class="item">
						<div class="label">{{ localizer.get("PrivateArea.Project.Email") }}</div>
					</div>
					<div class="item">
						<div class="input">
							<label v-if="allowedDomains">{{ localizer.get("PrivateArea.Project.EmailTolltip", allowedDomains) }}</label>
						</div>
					</div>
					<div class="item">
						<div class="input" data-info>
							<input type="email" id="Email" v-model.lazy="formData.email" :disabled="isLoadingForm" placeholder="email@domain.com" @keydown.enter.prevent.stop="submitForm()" :class="[{'input-validation-error': isValidationError('Email')}, 'textbox']" />
						</div>
					</div>
					<div class="item">
						<div v-if="!isLoadingForm" @click="submitForm()" class="button" :style="[{'background-color': accentColor}]">
							{{ localizer.get("PrivateArea.Project.Share") }}
						</div>
						<div v-else class="button load" :style="[{'background-color': accentColor}]"><div class="loader"></div></div>
					</div>
					<div v-if="validationErrors.length !== 0" class="validation-summary-errors">
						<ul>
							<li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
						</ul>
					</div>
				</div>
				<div v-if="!isLoading" class="list-user">
					<div class="title">{{ localizer.get("PrivateArea.Project.ProfileRelationList_Title") }}</div>
					<div v-if="projectProfiles.length === 0">{{ localizer.get("PrivateArea.Project.NoUser") }}</div>
					<div v-for="(projectProfile, index) in projectProfiles" :key="index" class="item">
						<div class="info">
							<div class="name">{{ projectProfile.email }}</div>
						</div>
						<button class="remove" @click="deleteAssociation(projectProfile.idMaster)" :disabled="isLoadingForm">{{ localizer.get("PrivateArea.Project.Remove") }}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

const props = defineProps<{
	projectIdMaster: string;
	accentColor: string;
	headerColor: string;
	menuColor: string;
	allowedDomains: string;
}>();

const store = useStore();
const localizer = Localizer;
const isLoading = ref(true);
const isLoadingForm = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const projectProfiles = ref<any[]>([]);
const validationErrors = ref<any[]>([]);
const routes = (window as any).App.routes;

const isProjectAssociationVisible = computed(() => store.getters["projectAssociationStore/isProjectAssociationVisible"]);

onMounted(async () => {
	await getData();
});

function closeDialog() {
	let body = document.getElementsByTagName("body")[0];
	store.commit("projectAssociationStore/setIsProjectAssociationVisible", false);

	if (body.hasAttribute("data-overflow")) {
		body.removeAttribute("data-overflow");
	}
}

async function getData() {
	isLoading.value = true;

	const result = (await Axios.post(routes.PrivateArea_Project_GetProjectAssociationData, { projectIdMaster: props.projectIdMaster })).data;
	projectProfiles.value = result;

	isLoading.value = false;
}

async function submitForm() {
	isLoadingForm.value = true;
	FormHelper.removeFocus();
	validationErrors.value = [];

	try {
		await Axios.post(routes.PrivateArea_Project_SetProjectAssociation, { projectIdMaster: props.projectIdMaster, email: formData.value.email });
		formData.value.email = null;
		await getData();
	} catch (error) {
		if (error.response && error.response.status === 400) {
			validationErrors.value = FormHelper.getValidationErrors(error.response.data);
		}
	}

	isLoadingForm.value = false;
}

async function deleteAssociation(idMaster: string) {
	var result = confirm(localizer.get("PrivateArea.Project.DeleteAssociation_Confirm"));
	if (result) {
		isLoadingForm.value = true;
		FormHelper.removeFocus();
		validationErrors.value = [];

		try {
			await Axios.post(routes.PrivateArea_Project_DeleteProjectAssociation, { projectIdMaster: props.projectIdMaster, userIdMaster: idMaster });

			await getData();
		} catch (error) {
			if (error.response && error.response.status === 400) {
				validationErrors.value = FormHelper.getValidationErrors(error.response.data);
			}
		}

		isLoadingForm.value = false;
	}
}

function isValidationError(controlName: string): boolean {
	return FormHelper.isControlValidationError(controlName, validationErrors.value);
}
</script>
